var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.15625 8.58991L5.19092 8.45026C5.24515 8.23094 5.09758 8.08212 4.30981 7.31477C3.91882 6.93372 3.4321 6.45952 3.0437 6.01752L3.02197 5.99519C2.76044 5.76212 2.52061 5.49623 2.32764 5.28205C2.17891 5.11635 2.05056 4.97552 1.94775 4.88361L1.86841 4.84467C2.17717 4.54097 2.63373 4.10504 3.11426 3.64667C5.24805 1.61113 5.25361 1.5943 5.21606 1.40449L5.1499 1.2176L5.01001 1.18366C4.79133 1.13009 4.62956 1.28859 3.80835 2.13935C3.40102 2.5612 2.89461 3.08575 2.40601 3.52619C2.15004 3.80629 1.86118 4.06797 1.62866 4.27827C1.4577 4.43343 1.31083 4.56669 1.2124 4.67268L1.14575 4.79523L1.14453 4.89252L1.15063 5.06062L1.2771 5.13398C1.30369 5.14967 1.33776 5.16331 1.37817 5.16779L1.37305 5.17915L1.48535 5.29963C2.02473 5.87816 2.62288 6.49432 3.36743 7.23786C3.8321 7.70532 4.2976 8.15077 4.7561 8.58833L4.86133 8.68928L5.15625 8.58991Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBtn);
export default __webpack_public_path__ + "static/media/left-btn.f523673ecc9faeec8833b0178b6ab111.svg";
export { ForwardRef as ReactComponent };